import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Image as ImageIcon, Plus, Download, Eye, MapPin, Building2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { toast } from 'sonner';

export default function Affiches({ user, onLogout }) {
  const [selectedAffiche, setSelectedAffiche] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const affiches = [
    {
      id: '1',
      titre: 'SESAM Guinée - Agence de Publicité',
      description: 'Affiche festive avec décorations dorées',
      url: 'https://customer-assets.emergentagent.com/job_sesam-crm/artifacts/0hcvfupy_IMG_2556.jpeg',
      type: 'Promotion',
      statut: 'Actif',
      client: 'SESAM Guinée',
      emplacement: 'KM5 - Avenue de l\'Indépendance',
      entreprise: 'SESAM Guinée'
    },
    {
      id: '2',
      titre: 'Exclusive Promo - 30% OFF',
      description: 'Promotion SOLDES 50%',
      url: 'https://customer-assets.emergentagent.com/job_sesam-crm/artifacts/p1d79xso_IMG_2555.jpeg',
      type: 'Promotion',
      statut: 'Actif',
      client: 'SESAM Guinée',
      emplacement: 'Rond-Point Lac - Centre Commercial',
      entreprise: 'SESAM Guinée'
    },
    {
      id: '3',
      titre: 'KEEHOM - Il est temps',
      description: 'Campagne de communication',
      url: 'https://customer-assets.emergentagent.com/job_sesam-crm/artifacts/l7mxal0a_IMG_2545.jpeg',
      type: 'Communication',
      statut: 'Actif',
      client: 'KEEHOM',
      emplacement: 'Ambassade USA - Quartier Diplomate',
      entreprise: 'KEEHOM SARL'
    },
    {
      id: '4',
      titre: 'Telecel RCA - Forfaits IRI MINGUI',
      description: 'Promotion opérateur télécom',
      url: 'https://customer-assets.emergentagent.com/job_sesam-crm/artifacts/enpkfgys_IMG_2542.jpeg',
      type: 'Télécommunication',
      statut: 'Actif',
      client: 'Telecel RCA',
      emplacement: 'Aéroport International - Zone Arrivées',
      entreprise: 'Telecel Centrafrique'
    },
    {
      id: '5',
      titre: 'Vœux du Président - Indépendance',
      description: 'Message officiel fêtes nationales',
      url: 'https://customer-assets.emergentagent.com/job_sesam-crm/artifacts/tkzvwrug_IMG_2543.jpeg',
      type: 'Institutionnel',
      statut: 'Actif',
      client: 'Burkina Faso',
      emplacement: 'Palais de Justice - Place de la République',
      entreprise: 'Gouvernement du Burkina Faso'
    }
  ];

  const handlePreview = (affiche) => {
    setSelectedAffiche(affiche);
    setShowPreview(true);
  };

  const handleViewDetails = (affiche) => {
    setSelectedAffiche(affiche);
    setShowDetails(true);
  };

  const handleDownload = (affiche) => {
    window.open(affiche.url, '_blank');
    toast.success(`Téléchargement de "${affiche.titre}"`);
  };

  const getTypeBadgeColor = (type) => {
    const colors = {
      'Promotion': 'bg-orange-100 text-orange-700',
      'Communication': 'bg-blue-100 text-blue-700',
      'Télécommunication': 'bg-red-100 text-red-700',
      'Institutionnel': 'bg-green-100 text-green-700'
    };
    return colors[type] || 'bg-gray-100 text-gray-700';
  };

  return (
    <Layout user={user} onLogout={onLogout} currentPage="affiches">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-600 rounded-lg flex items-center justify-center">
              <ImageIcon className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold">Affiches</h1>
              <p className="text-gray-600">{affiches.length} affiches disponibles</p>
            </div>
          </div>
          <Button className="bg-blue-600 hover:bg-blue-700 gap-2">
            <Plus className="h-4 w-4" />
            Nouvelle affiche
          </Button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card className="bg-gradient-to-br from-orange-50 to-white border-orange-200">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-600 mb-1">Affiches en Cours</div>
                  <div className="text-4xl font-bold text-orange-600">7</div>
                </div>
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <ImageIcon className="h-6 w-6 text-orange-600" />
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-blue-50 to-white border-blue-200">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-600 mb-1">Affiches Installées</div>
                  <div className="text-4xl font-bold text-blue-600">15</div>
                </div>
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <ImageIcon className="h-6 w-6 text-blue-600" />
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-green-50 to-white border-green-200">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-600 mb-1">Clients Actifs</div>
                  <div className="text-4xl font-bold text-green-600">8</div>
                </div>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <ImageIcon className="h-6 w-6 text-green-600" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Galerie d'affiches */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <ImageIcon className="h-5 w-5" />
              Galerie d'affiches SESAM
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {affiches.map((affiche) => (
                <div key={affiche.id} className="group relative">
                  <Card 
                    className="overflow-hidden hover:shadow-xl transition-all cursor-pointer border-2 hover:border-blue-300"
                    onClick={() => handleViewDetails(affiche)}
                  >
                    {/* Image - Taille réduite */}
                    <div className="relative h-64 bg-gray-100">
                      <img
                        src={affiche.url}
                        alt={affiche.titre}
                        className="w-full h-full object-cover"
                      />
                      
                      {/* Overlay on hover */}
                      <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
                        <Button
                          size="sm"
                          className="bg-white text-gray-900 hover:bg-gray-100"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePreview(affiche);
                          }}
                        >
                          <Eye className="h-4 w-4 mr-2" />
                          Aperçu
                        </Button>
                        <Button
                          size="sm"
                          className="bg-blue-600 hover:bg-blue-700"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownload(affiche);
                          }}
                        >
                          <Download className="h-4 w-4 mr-2" />
                          Télécharger
                        </Button>
                      </div>

                      {/* Status Badge */}
                      <div className="absolute top-3 right-3">
                        <Badge className="bg-green-500 text-white">Actif</Badge>
                      </div>
                    </div>

                    {/* Info */}
                    <CardContent className="p-4">
                      <h3 className="font-bold text-lg text-gray-900 mb-2 line-clamp-1">
                        {affiche.titre}
                      </h3>
                      <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                        {affiche.description}
                      </p>
                      <div className="flex items-center justify-between">
                        <Badge className={getTypeBadgeColor(affiche.type)}>
                          {affiche.type}
                        </Badge>
                        <span className="text-xs text-gray-500">{affiche.client}</span>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Preview Modal */}
      <Dialog open={showPreview} onOpenChange={setShowPreview}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          {selectedAffiche && (
            <div className="space-y-4">
              <div>
                <h2 className="text-2xl font-bold mb-2">{selectedAffiche.titre}</h2>
                <div className="flex items-center gap-2 mb-4">
                  <Badge className={getTypeBadgeColor(selectedAffiche.type)}>
                    {selectedAffiche.type}
                  </Badge>
                  <Badge className="bg-green-100 text-green-700">{selectedAffiche.statut}</Badge>
                  <span className="text-sm text-gray-600">Client: {selectedAffiche.client}</span>
                </div>
              </div>
              <img
                src={selectedAffiche.url}
                alt={selectedAffiche.titre}
                className="w-full rounded-lg"
              />
              <p className="text-gray-700">{selectedAffiche.description}</p>
              <div className="flex gap-2 pt-4">
                <Button
                  className="flex-1 bg-blue-600 hover:bg-blue-700"
                  onClick={() => handleDownload(selectedAffiche)}
                >
                  <Download className="h-4 w-4 mr-2" />
                  Télécharger
                </Button>
                <Button variant="outline" onClick={() => setShowPreview(false)}>
                  Fermer
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Details Modal */}
      <Dialog open={showDetails} onOpenChange={setShowDetails}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle className="text-2xl flex items-center gap-2">
              <ImageIcon className="h-6 w-6 text-purple-600" />
              Détails de l'Affiche
            </DialogTitle>
          </DialogHeader>
          
          {selectedAffiche && (
            <div className="space-y-6 mt-4">
              {/* Image Preview */}
              <div className="relative rounded-xl overflow-hidden border-2 border-gray-200">
                <img
                  src={selectedAffiche.url}
                  alt={selectedAffiche.titre}
                  className="w-full h-64 object-cover"
                />
              </div>

              {/* Info Cards */}
              <div className="grid gap-4">
                <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-5 rounded-xl border-2 border-purple-200">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{selectedAffiche.titre}</h3>
                  <p className="text-gray-700">{selectedAffiche.description}</p>
                  <div className="flex items-center gap-2 mt-3">
                    <Badge className={getTypeBadgeColor(selectedAffiche.type)}>
                      {selectedAffiche.type}
                    </Badge>
                    <Badge className="bg-green-100 text-green-700">{selectedAffiche.statut}</Badge>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Entreprise */}
                  <div className="bg-white p-5 rounded-lg border-2 border-blue-200">
                    <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                      <Building2 className="h-5 w-5 text-blue-600" />
                      Entreprise / Client
                    </div>
                    <div className="text-xl font-bold text-blue-900">{selectedAffiche.entreprise}</div>
                  </div>

                  {/* Emplacement */}
                  <div className="bg-white p-5 rounded-lg border-2 border-green-200">
                    <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                      <MapPin className="h-5 w-5 text-green-600" />
                      Emplacement du Panneau
                    </div>
                    <div className="text-lg font-bold text-green-900">{selectedAffiche.emplacement}</div>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex justify-between gap-2 pt-4 border-t">
                <Button variant="outline" onClick={() => setShowDetails(false)}>
                  Fermer
                </Button>
                <Button
                  className="bg-blue-600 hover:bg-blue-700 gap-2"
                  onClick={() => handleDownload(selectedAffiche)}
                >
                  <Download className="h-4 w-4" />
                  Télécharger
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
